import { BlockOne, BlockTwo, BlockThree, BlockFour, BlockFive, BlockSix, BlockSeven, BlockEight } from "./dependency";

const LandingMain = ({ post, props }) => {
  return (
    <>
      {post["Top"] !== null && <BlockOne data={post["Top"]} {...props} />}
      {post["Second"] !== null && <BlockTwo data={post["Second"]} {...props} />}
      {post["Third"] !== null && <BlockThree data={post["Third"]} {...props} />}
      {post["Quarter"] !== null && <BlockFour data={post["Quarter"]} />}
      {post["Fifth"] !== null && <BlockFive data={post["Fifth"]} {...props} />}
      {post["Sixth"] !== null && <BlockSix data={post["Sixth"]} {...props} />}
      {post["Seventh"] !== null && <BlockSeven data={post["Seventh"]} {...props} />}
      {post.related_pages.data.length > 0 && <BlockEight data={post.related_pages.data} />}
    </>
  )
}

export default LandingMain